import { render, staticRenderFns } from "./vermBseg.vue?vue&type=template&id=7544230b&scoped=true"
import script from "./vermBseg.vue?vue&type=script&lang=js"
export * from "./vermBseg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7544230b",
  null
  
)

export default component.exports